import httpClient from "../httpClient";
import { API_COMORBIDITY_LIST } from "../config";

const comorbidityListing = {
  getComorbidities: () => httpClient.get(API_COMORBIDITY_LIST),
};

export default comorbidityListing;